let targetedAdPromise = null;
let resolveTargetedAdPromise = null;

export function initTargetedEUAdsPromise() {
    if (!targetedAdPromise) {
        // tslint:disable-next-line:promise-must-complete
        targetedAdPromise = new Promise(resolve => (resolveTargetedAdPromise = resolve));
    }
}

/**
 * Function to be called by campaign to await on Targeted Ad Dimiss.
 * Will also create the targeted ad promise if not created yet.
 */
export function onTargetedEUAdsDismiss() {
    initTargetedEUAdsPromise();
    return targetedAdPromise;
}

/**
 * Function to resolve the targeted ad promise.
 * Called on "Continue to Site, Modal dismiss and when returning back to mail list view from options via close/back button."
 */
export function targetedEUAdsDismissed() {
    resolveTargetedAdPromise && resolveTargetedAdPromise();
}
